import Vue from 'vue'
import Router from 'vue-router'
import ReservationTicket from '../components/ReservationTicket'
import Term from '../components/Term'
import Privacy from '../components/Privacy'
import Attention from '../components/Attention'
import NotFound from '../components/NotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/reservationTicket',
      name: 'ReservationTicket',
      component: ReservationTicket
    },
    {
      path: '/term',
      name: 'Term',
      component: Term
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/attention',
      name: 'Attention',
      component: Attention
    },
    {
      path: '/*',
      name: 'Attention',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js